import React, {Component} from 'react';
import { Route, Switch} from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import {BaseServer} from "@project/shared/src/services/postData";
import FREETRIAL from "../pages/freeTrail";
import Contact from "../pages/contactUs";
import ACTIVATION from "../pages/activation";
import SITELOGIN from "../pages/login"
import SETPSW from "../pages/setPassword"
import SITEFORGOTPASSWORD from "../pages/forgotPassword";
import ThankYouPage from "../pages/contactUs/thankYouPage";

class Routes extends Component {

    render(){

        return(<BrowserRouter>



                <Switch>
                  <Route exact path={`${BaseServer}contactUs`} component={Contact}/>
                  <Route exact path={`${BaseServer}contactUsThankYou`} component={ThankYouPage}/>
                  <Route exact path={`${BaseServer}freetrial`} component={FREETRIAL}/>
                  <Route exact path={`${BaseServer}activation/:active`} component={ACTIVATION}/>
                  <Route exact path={`${BaseServer}login`} component={SITELOGIN}/>
                  {/* <Route exact path={`${BaseServer}forgotPassword`} component={SITEFORGOTPASSWORD}/> */}
                  <Route exact path={`${BaseServer}setPsw/:user/:active/:lic`} component={SETPSW}/>
                </Switch>





        </BrowserRouter>)
    }

}
export default Routes;
